'use strict';
module.exports = require('./lib/index.js');



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/index.js
// module id = 213
// module chunks = 96961042003272 139266963665775